import { Link } from '@remix-run/react'
import { memo } from 'react'
import { Separator } from '#app/shared/ui/data-display/Separator.js'
import { Button } from '#app/shared/ui/inputs/button/Button.js'
// import GoogleReviews from '#app/shared/ui/others/GoogleReviews.js'
import HeroFooter from './HeroFooter'

const HERO_LINKS = {
  cars: '/nuestros-coches',
  us: '/sobre-nosotros',
} as const

// const MemoizedGoogleReviews = memo(GoogleReviews)
const MemoizedHeroFooter = memo(HeroFooter)

const MainButton = () => (
  <Link to={HERO_LINKS.cars}>
    <Button
      variant="primary"
      className={`
        h-[34px] w-[184px] text-nowrap

        md:h-11 md:w-[170px]
      `}
    >
      <span
        className={`
          text-subtitle1-medium

          md:text-base-medium
        `}
      >
        Nuestros coches
      </span>
    </Button>
  </Link>
)

const CustomButton = () => (
  <Link to={HERO_LINKS.us}>
    <Button
      variant="outlineInput"
      className={`
        h-[34px] w-[184px] text-nowrap text-white

        md:h-11 md:w-[114px]
      `}
      style={{ fontSize: '14px' }}
    >
      <span
        className={`
          text-subtitle1-medium

          md:text-base-medium
        `}
      >
        <span className="md:hidden">Conocenos</span>
        <span
          className={`
            hidden

            md:inline
          `}
        >
          Nosotros
        </span>
      </span>
    </Button>
  </Link>
)

interface HeroProps {}

export default function Hero({}: HeroProps) {
  return (
    <div className={`flex h-full flex-col items-center justify-end`}>
      {/* Main Content */}
      <section
        className={`
          flex -translate-y-4 flex-col items-center justify-end

          lg:-translate-y-8
        `}
      >
        <p
          className={`
            w-[265px] text-center font-saira text-h3 font-bold text-white

            lg:w-[470px] lg:text-[56px] lg:leading-[56px]
          `}
        >
          Coches premium a precios óptimos
        </p>
        <p
          className={`
            mt-5 hidden w-[328px] px-4 text-center text-base-medium text-white

            lg:mt-6 lg:w-[492px] lg:text-base-semibold

            md:block
          `}
        >
          Vehículos de ocasión seleccionados con criterio. Garantía,
          transparencia total y entrega inmediata.
        </p>

        {/* Call to Action Buttons */}
        <div
          className={`
            mb-5 mt-5 flex w-full flex-col items-center gap-3

            lg:mb-0 lg:mt-6 lg:gap-4

            md:flex-row md:justify-center
          `}
        >
          <MainButton />
          <CustomButton />
        </div>
      </section>

      {/* Bottom Section */}
      <footer className="w-full">
        <div
          className={`
            mt-9 hidden px-3

            lg:block
          `}
        >
          <Separator
            className={`!rounded-lg bg-line-gradient-light opacity-[37%]`}
          />
        </div>

        <MemoizedHeroFooter />
      </footer>
    </div>
  )
}
